{
  "Earlier": "PRECEDENTI",
  "noAnnouncements": "Riceverai informazioni sulle attività di manutenzione programmate e sulla risoluzione di problemi del prodotto",
  "noAnnouncementsTitle": "Gli avvisi verranno visualizzati qui"
}
